import React from 'react';
import { Table } from 'rsuite';
import { CompactHeaderCell, CompactCell } from 'Components/Common/Table/CustomCells';
import { NumericFormat } from 'react-number-format';
import { EsatusStack } from 'Components/Common/Detail/EstatusStack';
import { ActionCell } from 'Components/Common/Table/CustomMenu';

const { Column, ColumnGroup, Cell, HeaderCell } = Table;

const FSECustomTable = ({ data, loading, onSelectAction }) => {
  // Safety wrapper for cell renderers
  const safeRender = (renderFn) => (rowData) => {
    if (!rowData || !rowData.dte) return '-';
    try {
      return renderFn(rowData);
    } catch (error) {
      console.error('Render error:', error);
      return '-';
    }
  };

  return (
    <Table
      headerHeight={80}
      rowHeight={35}
      data={data || []}
      loading={loading}
      bordered
      autoHeight
      cellBordered
      renderEmpty={() => (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          No hay documentos FSE para mostrar
        </div>
      )}
    >
      <ColumnGroup align="center" header="Identificación">
        <Column width={120} align="center">
          <CompactHeaderCell>Tipo DTE</CompactHeaderCell>
          <CompactCell dataKey="tipoDte">
            {safeRender((rowData) => `${rowData.dte.identificacion?.tipoDte || '-'}`)}
          </CompactCell>
        </Column>
        <Column width={120} align="center">
          <CompactHeaderCell>Número Control</CompactHeaderCell>
          <CompactCell dataKey="numeroControl">
            {safeRender((rowData) => `${rowData.dte.identificacion?.numeroControl || '-'}`)}
          </CompactCell>
        </Column>
      </ColumnGroup>

      <ColumnGroup align="center" header="Emisor">
        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>NIT</CompactHeaderCell>
          <CompactCell dataKey="nit">
            {safeRender((rowData) => `${rowData.dte.emisor?.nit || '-'}`)}
          </CompactCell>
        </Column>
        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>NRC</CompactHeaderCell>
          <CompactCell dataKey="nrc">
            {safeRender((rowData) => `${rowData.dte.emisor?.nrc || '-'}`)}
          </CompactCell>
        </Column>
        <Column width={200} align="left" resizable>
          <CompactHeaderCell>Nombre</CompactHeaderCell>
          <CompactCell dataKey="nombree">
            {safeRender((rowData) => `${rowData.dte.emisor?.nombre || '-'}`)}
          </CompactCell>
        </Column>
      </ColumnGroup>

      <ColumnGroup align="center" header="Sujeto Excluido">
        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>Tipo Doc.</CompactHeaderCell>
          <CompactCell dataKey="tipoDoc">
            {safeRender((rowData) => `${rowData.dte.sujetoExcluido?.tipoDocumento || '-'}`)}
          </CompactCell>
        </Column>
        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>Número Doc.</CompactHeaderCell>
          <CompactCell dataKey="numDocumento">
            {safeRender((rowData) => `${rowData.dte.sujetoExcluido?.numDocumento || '-'}`)}
          </CompactCell>
        </Column>
        <Column width={280} align="right" resizable>
          <CompactHeaderCell>Nombre</CompactHeaderCell>
          <CompactCell dataKey="nombres">
            {safeRender((rowData) => `${rowData.dte.sujetoExcluido?.nombre || '-'}`)}
          </CompactCell>
        </Column>
        <Column width={280} align="right" resizable>
          <CompactHeaderCell>Correo</CompactHeaderCell>
          <CompactCell dataKey="correos">
            {safeRender((rowData) => `${rowData.dte.sujetoExcluido?.correo || '-'}`)}
          </CompactCell>
        </Column>
      </ColumnGroup>

      <Column width={330} align="center" resizable fullText>
        <CompactHeaderCell>Código de generación</CompactHeaderCell>
        <CompactCell dataKey="codigoGeneracion">
          {safeRender((rowData) => `${rowData.dte.identificacion?.codigoGeneracion || '-'}`)}
        </CompactCell>
      </Column>

      <ColumnGroup align="center" header="Resumen">
        <Column width={130} align="right" colSpan={2}>
          <CompactHeaderCell>Total (USD)</CompactHeaderCell>
          <CompactCell dataKey="totalPagar">
            {safeRender((rowData) => {   
              if (!rowData.dte.resumen) return '-'
              return <NumericFormat
                value={
                  rowData.dte.resumen.totalPagar
                    ? rowData.dte.resumen.totalPagar
                    : rowData.dte.resumen.montoTotalOperacion
                    ? rowData.dte.resumen.montoTotalOperacion
                    : 0
                }
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
              />
            })}
          </CompactCell>
        </Column>
      </ColumnGroup>

      <Column width={370} align="center" colSpan={2}>
        <CompactHeaderCell>Sello de recibido</CompactHeaderCell>
        <CompactCell dataKey="selloRecibido">
          {safeRender((rowData) => (rowData.recepcion ? `${rowData.recepcion.selloRecibido ?? '-'}` : 'Sin sello'))}
        </CompactCell>
      </Column>

      <Column width={320} align="left">
        <CompactHeaderCell>Estatus</CompactHeaderCell>
        <CompactCell align="left" dataKey="estatus">
          {safeRender((rowData) => (            
            <EsatusStack estatus={rowData.estatus} validationResult={rowData.validationResult} otherValidationsResult={rowData.otherValidationsResult}/>            
          ))}
        </CompactCell>
      </Column>
      <Column width={80} fixed="right" align="center">
        <CompactHeaderCell>Acciones</CompactHeaderCell>
        <ActionCell dataKey="id" onSelect={onSelectAction} />
      </Column>
    </Table>
  );
};

export default FSECustomTable;
